import  {configureStore} from "@reduxjs/toolkit";
import languageReducer from "./reduxSlices/languageSlices";
import voiceReducer from "./reduxSlices/voiceSlices";
import feedbackReducer from "./reduxSlices/feedback";
import movewidgetReducer from "./reduxSlices/moveWidget";
import resetToggleReducer from "./reduxSlices/resetToggleSlice";import profiledataReducer from "./reduxSlices/profile";
import dictionaryReducer from "./reduxSlices/dictionarySlices";
import booleanReducer from "./reduxSlices/booleanSlice";
import keyboardReducer from "./reduxSlices/keyboardSlices";
import hideInterfaceReducer from "./reduxSlices/hideInterfaceSlice";
export const store=configureStore({
    devTools:true,
    reducer:{
        language:languageReducer,
        voice:voiceReducer,
        feedback:feedbackReducer,
        movewidget:movewidgetReducer,
        resetToggle:resetToggleReducer,
        profiledata:profiledataReducer,
        dictionary:dictionaryReducer,
        boolean:booleanReducer,
        keyboard:keyboardReducer,
        HideInterface: hideInterfaceReducer,
    },
    
})